<!-- <div class="nav d-flex justify-content-between px-3 py-2" *ngIf="scrWidth > 475" (click)="closeEditor()">
  <div class="d-flex gap-2" style="width: 20%;">
    <button class="border" data-bs-target="#staticBackdrop" data-bs-toggle="modal"
      style="width: 25%; border-radius: 5px;font-size: 14px; font-weight: 600;background-color: white;">Exit</button>
    <button (click)="savePage()" class="border"
      style="width: 25%; border-radius: 5px;font-size: 14px; font-weight: 600;background-color: white;">Save</button>
  </div>
  <div class="add_business d-flex justify-content-end" style="width: 30%; gap: 7px;">
    <div class="add_page d-flex justify-content-between align-items-center" (click)="pageListComponent()">
      
      <div class="home-text">
        {{selectedPage}}
      </div>
      <div>
        <img src="../../../assets/images/home_page/Vector.svg" alt="">
      </div>
    </div>
    <div class="multi_page d-flex border"
      style="width: fit-content; border-radius: 5px;font-size: 14px; font-weight: 600;background-color: white; height: 40px;"
      (click)="pageListComponent('ADD_PAGE')">
      <button class="button-style d-flex justify-content-center align-items-center ww-100"
        style="border: none; border-radius: 5px;">
        <mat-icon>add</mat-icon></button>
    </div>
  </div>
  <div style="width: 40%;">
    <div class="d-flex gap-3 justify-content-end h-100">
      <button class="button-style d-flex justify-content-center align-items-center border" [matMenuTriggerFor]="menu"
        style="width: fit-content; border: 1px; border-radius: 5px;font-size: 14px; font-weight: 500;background-color: white; display: flex; gap: 6px;">
        <svg style="width: 18px;" width="15" height="15" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.81 3.94C20.27 7.78 16.41 13 13.18 15.59L11.21 17.17C10.96 17.35 10.71 17.51 10.43 17.62C10.43 17.44 10.42 17.24 10.39 17.05C10.28 16.21 9.90002 15.43 9.23002 14.76C8.55002 14.08 7.72002 13.68 6.87002 13.57C6.67002 13.56 6.47002 13.54 6.27002 13.56C6.38002 13.25 6.55002 12.96 6.76002 12.72L8.32002 10.75C10.9 7.52 16.14 3.64 19.97 2.11C20.56 1.89 21.13 2.05 21.49 2.42C21.87 2.79 22.05 3.36 21.81 3.94Z"
            stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          <path
            d="M10.43 17.62C10.43 18.72 10.01 19.77 9.22003 20.57C8.61003 21.18 7.78003 21.6 6.79003 21.73L4.33003 22C2.99003 22.15 1.84003 21.01 2.00003 19.65L2.27003 17.19C2.51003 15 4.34003 13.6 6.28003 13.56C6.48003 13.55 6.69003 13.56 6.88003 13.57C7.73003 13.68 8.56003 14.07 9.24003 14.76C9.91003 15.43 10.29 16.21 10.4 17.05C10.41 17.24 10.43 17.43 10.43 17.62Z"
            stroke="#292D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M14.24 14.47C14.24 11.86 12.12 9.73999 9.51001 9.73999" stroke="#000000" stroke-width="1.5"
            stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        Customize
        <div>
          <img src="../../../assets/images/home_page/Vector.svg" alt="" class="w-15">
        </div>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="open('color')" type="button" data-bs-toggle="offcanvas" data-bs-target="#sideBar"
          aria-controls="offcanvasRight">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.1963 2H11.8115C6.39277 2 2 6.39277 2 11.8115V12.1962C2 16.7152 5.23178 20.5876 9.67788 21.396C11.2846 21.6881 12.6881 20.2846 12.396 18.6779L12 16.5C11.5164 13.8399 13.8399 11.5164 16.5 12L18.6779 12.396C20.2846 12.6881 21.6881 11.2846 21.396 9.67788C20.5876 5.23178 16.7152 2 12.1963 2Z"
              stroke="#17191C" stroke-width="1.5"></path>
            <path
              d="M14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7C13.5523 7 14 7.44772 14 8Z"
              fill="#17191C"></path>
            <path
              d="M10 7C10 7.55228 9.55228 8 9 8C8.44772 8 8 7.55228 8 7C8 6.44772 8.44772 6 9 6C9.55228 6 10 6.44772 10 7Z"
              fill="#17191C"></path>
            <path
              d="M8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10Z"
              fill="#17191C"></path>
            <path
              d="M9 14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13C8.55228 13 9 13.4477 9 14Z"
              fill="#17191C"></path>
          </svg>
          <span class="window-titles">Colors</span></button>
        <button mat-menu-item (click)="open('font')" type="button" data-bs-toggle="offcanvas" data-bs-target="#sideBar"
          aria-controls="offcanvasRight">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H15C20 2 22 4 22 9V15C22 20 20 22 15 22Z" stroke="#17191C"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path
              d="M10.7954 16L10.2261 14.1309H7.36328L6.79395 16H5L7.77148 8.11523H9.80713L12.5894 16H10.7954ZM9.82861 12.7344L9.25928 10.9082C9.22347 10.7865 9.17513 10.6307 9.11426 10.4409C9.05697 10.2476 8.99788 10.0524 8.93701 9.85547C8.87972 9.65495 8.83317 9.48128 8.79736 9.33447C8.76156 9.48128 8.71143 9.6639 8.64697 9.88232C8.5861 10.0972 8.52702 10.3013 8.46973 10.4946C8.41243 10.688 8.37126 10.8258 8.34619 10.9082L7.78223 12.7344H9.82861ZM15.9141 9.87158C16.7197 9.87158 17.3374 10.047 17.7671 10.3979C18.1968 10.7489 18.4116 11.2824 18.4116 11.9985V16H17.2676L16.9507 15.1836H16.9077C16.7358 15.3984 16.5604 15.5739 16.3813 15.71C16.2023 15.846 15.9964 15.9463 15.7637 16.0107C15.5309 16.0752 15.248 16.1074 14.915 16.1074C14.5605 16.1074 14.2419 16.0394 13.959 15.9033C13.6797 15.7673 13.4595 15.5596 13.2983 15.2803C13.1372 14.9974 13.0566 14.6393 13.0566 14.2061C13.0566 13.5687 13.2804 13.0996 13.728 12.7988C14.1756 12.4945 14.847 12.3262 15.7422 12.2939L16.7842 12.2617V11.9985C16.7842 11.6834 16.7018 11.4525 16.5371 11.3057C16.3724 11.1589 16.1432 11.0854 15.8496 11.0854C15.5596 11.0854 15.2749 11.1266 14.9956 11.209C14.7163 11.2913 14.437 11.3952 14.1577 11.5205L13.6152 10.4141C13.9339 10.2458 14.2902 10.1133 14.6841 10.0166C15.0815 9.91992 15.4915 9.87158 15.9141 9.87158ZM16.7842 13.2178L16.1504 13.2393C15.6204 13.2536 15.2516 13.3485 15.0439 13.5239C14.8398 13.6994 14.7378 13.9303 14.7378 14.2168C14.7378 14.4674 14.8112 14.6465 14.958 14.7539C15.1048 14.8577 15.2964 14.9097 15.5327 14.9097C15.8836 14.9097 16.179 14.8058 16.4189 14.5981C16.6624 14.3905 16.7842 14.0951 16.7842 13.7119V13.2178Z"
              fill="black"></path>
          </svg>
          <span class="window-titles">Fonts</span>
        </button>
      </mat-menu>

      <mat-menu #screens="matMenu">
        <button mat-menu-item type="button">
          <mat-icon>desktop_windows</mat-icon>Desktop</button>
        <button mat-menu-item type="button">
          <mat-icon>tablet</mat-icon>Tablet</button>
        <button mat-menu-item type="button">
          <mat-icon>smartphone</mat-icon>Mobile</button>
      </mat-menu>
      <button *ngIf="status === 'PUBLISHED' && isDefaultTemplate"
        class="view d-flex justify-content-center alig-items-center border" (click)="viewPopup()"
        style="width: 15%; border: 1px; border-radius: 5px;font-size: 14px; font-weight: 600;background-color: white; ">
        
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="15" height="15" fill="currentColor"
          aria-hidden="true" class="icon w-5 h-5">
          <path fill-rule="evenodd"
            d="M4.25 5.5a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75v-4a.75.75 0 011.5 0v4A2.25 2.25 0 0112.75 17h-8.5A2.25 2.25 0 012 14.75v-8.5A2.25 2.25 0 014.25 4h5a.75.75 0 010 1.5h-5z"
            clip-rule="evenodd"></path>
          <path fill-rule="evenodd"
            d="M6.194 12.753a.75.75 0 001.06.053L16.5 4.44v2.81a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h2.553l-9.056 8.194a.75.75 0 00-.053 1.06z"
            clip-rule="evenodd"></path>
        </svg>
        View
      </button>
      <button *ngIf="status === 'NOT_PUBLISHED' && isDefaultTemplate"
        class="view d-flex justify-content-center alig-items-center border" (click)="changeStatus()"
        style="width: 15%; border: 1px; border-radius: 5px;font-size: 14px; font-weight: 600;background-color: white; height: 40px;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"
          class="icon w-5 h-5">
          <path fill-rule="evenodd"
            d="M4.606 12.97a.75.75 0 01-.134 1.051 2.494 2.494 0 00-.93 2.437 2.494 2.494 0 002.437-.93.75.75 0 111.186.918 3.995 3.995 0 01-4.482 1.332.75.75 0 01-.461-.461 3.994 3.994 0 011.332-4.482.75.75 0 011.052.134z"
            clip-rule="evenodd"></path>
          <path fill-rule="evenodd"
            d="M5.752 12A13.07 13.07 0 008 14.248v4.002c0 .414.336.75.75.75a5 5 0 004.797-6.414 12.984 12.984 0 005.45-10.848.75.75 0 00-.735-.735 12.984 12.984 0 00-10.849 5.45A5 5 0 001 11.25c.001.414.337.75.751.75h4.002zM13 9a2 2 0 100-4 2 2 0 000 4z"
            clip-rule="evenodd"></path>
        </svg>
        Publish
      </button>

    </div>
  </div>

  <div class="custom-sidebar" [class.open]="isSidebarOpen">
    <div class="sidebar-header">
      <p *ngIf="selectedGlobal === 'color'" class="header-text mb-0">Color Palette</p>
      <p *ngIf="selectedGlobal === 'buttons'" class="header-text mb-0">Button Styles</p>
      <p *ngIf="selectedGlobal === 'font'" class="header-text mb-0">Fonts</p>
      <p *ngIf="selectedGlobal === 'others'" class="header-text mb-0">Other Styles</p>
      <button class="doneBtn" (click)="closeSidebar()">Done</button>
    </div>

    <div class="sidebar-body">
      <div *ngIf="selectedGlobal === 'color'">
        <app-bg-color-palette [templatePage]="templatePage" [themes]="themes"></app-bg-color-palette>
      </div>
      <div class="buttons" *ngIf="selectedGlobal === 'buttons'">
        <app-global-button-styles [templatePage]="templatePage"></app-global-button-styles>
      </div>
      <div class="fonts" *ngIf="selectedGlobal === 'font'">
        <div class="font-list">
          <div class="font-card" *ngFor="let item of fontFamilies"
            [class.font-card--selected]="item.text === selectedFont"
            (click)="selectedFontFamily(item)">
            <div class="font-card__preview" [style.fontFamily]="item.text">Aa</div>
            <div class="font-card__info">
              <div class="font-card__name" [style.fontFamily]="item.text">{{item.text}}</div>
              <div class="font-card__sub">{{item.subtext}}</div>
            </div>
            <svg *ngIf="item.text === selectedFont" class="font-card__check"
              xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
              fill="none" stroke="var(--primary-bg-color)" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          </div>
        </div>
      </div>

      <div class="other_styles" *ngIf="selectedGlobal === 'others'">
        <app-other-styles [templatePage]="templatePage"></app-other-styles>
      </div>
    </div>
  </div>
</div> -->
<nav class="toolbar">
  <!-- Left -->
  <div class="toolbar-left">
    <button class="btn-back" data-bs-target="#staticBackdrop" data-bs-toggle="modal">
      <mat-icon>keyboard_backspace</mat-icon>
      Back to Dashboard
    </button>

    <div class="divider"></div>

    <div class="save-group">
      <button class="btn-save" (click)="savePage()" *ngIf="!showSavedStatus">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-save" aria-hidden="true">
          <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z">
          </path>
          <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"></path>
          <path d="M7 3v4a1 1 0 0 0 1 1h7"></path>
        </svg>
        Save
      </button>
      <span *ngIf="showSavedStatus"><mat-icon>check</mat-icon>Saved</span>
    </div>
  </div>

  <!-- Center -->
  <div class="toolbar-center">
    <button class="btn-page" (click)="pageListComponent()">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-file-text" aria-hidden="true">
        <path
          d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z">
        </path>
        <path d="M14 2v5a1 1 0 0 0 1 1h5"></path>
        <path d="M10 9H8"></path>
        <path d="M16 13H8"></path>
        <path d="M16 17H8"></path>
      </svg>
      {{selectedPage}}
      <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 9l6 6 6-6" />
      </svg>
    </button>
  </div>

  <!-- Right -->
  <div class="toolbar-right">
    <div class="design-menu-wrap" (click)="$event.stopPropagation()">
      <button class="btn-design" (click)="toggleDesignMenu($event)">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-palette" aria-hidden="true">
          <path d="M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z"/>
          <circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/>
          <circle cx="17.5" cy="10.5" r=".5" fill="currentColor"/>
          <circle cx="6.5" cy="12.5" r=".5" fill="currentColor"/>
          <circle cx="8.5" cy="7.5" r=".5" fill="currentColor"/>
        </svg>
        Design
      </button>

      <!-- Custom design dropdown -->
      <div class="design-dropdown" *ngIf="isDesignMenuOpen">
        <button class="design-item" (click)="open('color'); isDesignMenuOpen=false"
          type="button" data-bs-toggle="offcanvas" data-bs-target="#sideBar" aria-controls="offcanvasRight">
          <div class="design-item__icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.1963 2H11.8115C6.39277 2 2 6.39277 2 11.8115V12.1962C2 16.7152 5.23178 20.5876 9.67788 21.396C11.2846 21.6881 12.6881 20.2846 12.396 18.6779L12 16.5C11.5164 13.8399 13.8399 11.5164 16.5 12L18.6779 12.396C20.2846 12.6881 21.6881 11.2846 21.396 9.67788C20.5876 5.23178 16.7152 2 12.1963 2Z" stroke="#374151" stroke-width="1.5"/>
              <path d="M14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7C13.5523 7 14 7.44772 14 8Z" fill="#374151"/>
              <path d="M10 7C10 7.55228 9.55228 8 9 8C8.44772 8 8 7.55228 8 7C8 6.44772 8.44772 6 9 6C9.55228 6 10 6.44772 10 7Z" fill="#374151"/>
              <path d="M8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10Z" fill="#374151"/>
              <path d="M9 14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13C8.55228 13 9 13.4477 9 14Z" fill="#374151"/>
            </svg>
          </div>
          <span class="design-item__label">Colors</span>
        </button>
        <button class="design-item" (click)="open('font'); isDesignMenuOpen=false"
          type="button" data-bs-toggle="offcanvas" data-bs-target="#sideBar" aria-controls="offcanvasRight">
          <div class="design-item__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="#374151" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="4 7 4 4 20 4 20 7"/>
              <line x1="9" y1="20" x2="15" y2="20"/>
              <line x1="12" y1="4" x2="12" y2="20"/>
            </svg>
          </div>
          <span class="design-item__label">Fonts</span>
        </button>
      </div>
    </div>
    <button class="btn-preview" (click)="viewPopup()">
      <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
      Preview
    </button>
  </div>
  <div class="custom-sidebar" [class.open]="isSidebarOpen">
    <div class="sidebar-header">
      <p *ngIf="selectedGlobal === 'color'" class="header-text mb-0">Color Palette</p>
      <p *ngIf="selectedGlobal === 'buttons'" class="header-text mb-0">Button Styles</p>
      <p *ngIf="selectedGlobal === 'font'" class="header-text mb-0">Fonts</p>
      <p *ngIf="selectedGlobal === 'others'" class="header-text mb-0">Other Styles</p>
      <button class="doneBtn" (click)="closeSidebar()">Done</button>
    </div>

    <div class="sidebar-body">
      <div *ngIf="selectedGlobal === 'color'">
        <app-bg-color-palette [templatePage]="templatePage" [themes]="themes"></app-bg-color-palette>
      </div>
      <div class="buttons" *ngIf="selectedGlobal === 'buttons'">
        <app-global-button-styles [templatePage]="templatePage"></app-global-button-styles>
      </div>
      <div class="fonts" *ngIf="selectedGlobal === 'font'">
        <div class="font-list">
          <div class="font-card" *ngFor="let item of fontFamilies"
            [class.font-card--selected]="item.text === selectedFont"
            (click)="selectedFontFamily(item)">
            <div class="font-card__preview" [style.fontFamily]="item.text">Aa</div>
            <div class="font-card__info">
              <div class="font-card__name" [style.fontFamily]="item.text">{{item.text}}</div>
              <div class="font-card__sub">{{item.subtext}}</div>
            </div>
            <svg *ngIf="item.text === selectedFont" class="font-card__check"
              xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
              fill="none" stroke="var(--primary-bg-color)" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 6 9 17l-5-5"/>
            </svg>
          </div>
        </div>
      </div>

      <div class="other_styles" *ngIf="selectedGlobal === 'others'">
        <app-other-styles [templatePage]="templatePage"></app-other-styles>
      </div>
    </div>
  </div>
</nav>
<div class="editor-part">
  <ng-container *ngIf="templatePage.length > 0 && themes.length > 0">
    <app-v3-editor [templatePage]="templatePage" [currentPageId]="currentPageId" [themes]="themes"
      (websiteLoaderfun)="getWebsiteLoader=$event"></app-v3-editor>
  </ng-container>
  <section class="loader_section" *ngIf="getWebsiteLoader">
    <div class="api_loader">
      <app-anime-loader></app-anime-loader>
    </div>
  </section>

</div>

<div *ngIf="scrWidth < 475" class="footer-section">
  <div class="footer-buttons">



    <div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
      <div class="offcanvas-body">
        <div class="option" (click)="open('color')" type="button" data-bs-toggle="offcanvas" data-bs-target="#sideBar"
          aria-controls="offcanvasRight">
          <!-- <mat-icon>palette</mat-icon>Colors -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 20 20" width="24"
            height="24" class="icon w-5 h-5 text-gray-700" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M10 17.5c-1.98912 0-3.89678-.7902-5.3033-2.1967C3.29018 13.8968 2.5 11.9891 2.5 10c0-1.98912.79018-3.89678 2.1967-5.3033S8.01088 2.5 10 2.5c4.1417 0 7.5 2.985 7.5 6.66667 0 .88333-.395 1.73163-1.0983 2.35663-.7034.625-1.6575.9767-2.6517.9767h-2.0833c-.3718-.006-.7349.1125-1.0316.3367-.2967.2241-.5099.541-.6057.9003-.09578.3593-.0687.7403.077 1.0824.1456.3421.4015.6257.7269.8056.1664.1535.2805.3553.3263.5771.0458.2217.021.4522-.071.6591-.0919.2068-.2464.3797-.4416.4943-.1953.1146-.4215.1651-.647.1445Z">
            </path>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M6.25 8.75c0 .22101.0878.43298.24408.58926.15628.15628.36824.24407.58925.24407.22102 0 .43298-.08779.58926-.24407.15628-.15628.24408-.36825.24408-.58926 0-.22101-.0878-.43298-.24408-.58926-.15628-.15628-.36824-.24407-.58926-.24407-.22101 0-.43297.08779-.58925.24407C6.3378 8.31702 6.25 8.52899 6.25 8.75Zm3.33333-2.5c0 .22101.0878.43298.24408.58926.15628.15628.36829.24407.58929.24407.221 0 .4329-.08779.5892-.24407.1563-.15628.2441-.36825.2441-.58926 0-.22101-.0878-.43298-.2441-.58926-.1563-.15628-.3682-.24407-.5892-.24407-.221 0-.43301.08779-.58929.24407-.15628.15628-.24408.36825-.24408.58926Zm3.33337 2.5c0 .22101.0878.43298.244.58926.1563.15628.3683.24407.5893.24407.221 0 .433-.08779.5893-.24407.1562-.15628.244-.36825.244-.58926 0-.22101-.0878-.43298-.244-.58926-.1563-.15628-.3683-.24407-.5893-.24407-.221 0-.433.08779-.5893.24407-.1562.15628-.244.36825-.244.58926Z">
            </path>
          </svg>
          <span class="window-titles">Colors</span>
        </div>
        <div class="option" (click)="open('font')" type="button" data-bs-toggle="offcanvas" data-bs-target="#sideBar"
          aria-controls="offcanvasRight">
          <!-- <mat-icon>font_download</mat-icon>Fonts -->
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H15C20 2 22 4 22 9V15C22 20 20 22 15 22Z" stroke="#17191C"
              stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            <path
              d="M10.7954 16L10.2261 14.1309H7.36328L6.79395 16H5L7.77148 8.11523H9.80713L12.5894 16H10.7954ZM9.82861 12.7344L9.25928 10.9082C9.22347 10.7865 9.17513 10.6307 9.11426 10.4409C9.05697 10.2476 8.99788 10.0524 8.93701 9.85547C8.87972 9.65495 8.83317 9.48128 8.79736 9.33447C8.76156 9.48128 8.71143 9.6639 8.64697 9.88232C8.5861 10.0972 8.52702 10.3013 8.46973 10.4946C8.41243 10.688 8.37126 10.8258 8.34619 10.9082L7.78223 12.7344H9.82861ZM15.9141 9.87158C16.7197 9.87158 17.3374 10.047 17.7671 10.3979C18.1968 10.7489 18.4116 11.2824 18.4116 11.9985V16H17.2676L16.9507 15.1836H16.9077C16.7358 15.3984 16.5604 15.5739 16.3813 15.71C16.2023 15.846 15.9964 15.9463 15.7637 16.0107C15.5309 16.0752 15.248 16.1074 14.915 16.1074C14.5605 16.1074 14.2419 16.0394 13.959 15.9033C13.6797 15.7673 13.4595 15.5596 13.2983 15.2803C13.1372 14.9974 13.0566 14.6393 13.0566 14.2061C13.0566 13.5687 13.2804 13.0996 13.728 12.7988C14.1756 12.4945 14.847 12.3262 15.7422 12.2939L16.7842 12.2617V11.9985C16.7842 11.6834 16.7018 11.4525 16.5371 11.3057C16.3724 11.1589 16.1432 11.0854 15.8496 11.0854C15.5596 11.0854 15.2749 11.1266 14.9956 11.209C14.7163 11.2913 14.437 11.3952 14.1577 11.5205L13.6152 10.4141C13.9339 10.2458 14.2902 10.1133 14.6841 10.0166C15.0815 9.91992 15.4915 9.87158 15.9141 9.87158ZM16.7842 13.2178L16.1504 13.2393C15.6204 13.2536 15.2516 13.3485 15.0439 13.5239C14.8398 13.6994 14.7378 13.9303 14.7378 14.2168C14.7378 14.4674 14.8112 14.6465 14.958 14.7539C15.1048 14.8577 15.2964 14.9097 15.5327 14.9097C15.8836 14.9097 16.179 14.8058 16.4189 14.5981C16.6624 14.3905 16.7842 14.0951 16.7842 13.7119V13.2178Z"
              fill="black"></path>
          </svg>
          <span class="window-titles">Fonts</span>
        </div>
        <div class="option" (click)="open('buttons')" type="button" data-bs-toggle="offcanvas" data-bs-target="#sideBar"
          aria-controls="offcanvasRight">
          <!-- <mat-icon>smart_button</mat-icon>Buttons -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" width="24" height="24"
            class="icon w-5 h-5 text-gray-700" aria-hidden="true">
            <rect width="14.5" height="5.5" x="2.75" y="2.75" fill="currentColor" stroke="currentColor"
              stroke-width="1.5" rx="2.25"></rect>
            <rect width="14.5" height="5.5" x="2.75" y="11.75" stroke="currentColor" stroke-width="1.5" rx="2.25">
            </rect>
          </svg>
          <span class="window-titles">Buttons</span>
        </div>
        <div class="option" (click)="open('others')" type="button" data-bs-toggle="offcanvas" data-bs-target="#sideBar"
          aria-controls="offcanvasRight">
          <!-- <mat-icon>format_shapes</mat-icon>Other styles -->
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" width="24" height="24"
            class="icon w-5 h-5 text-gray-700" aria-hidden="true">
            <path
              d="M12.4632 14.7277c.3088.3149.6854.4723 1.13.4723.4446 0 .8236-.1574 1.1369-.4723.3133-.3148.47-.7006.47-1.1574 0-.3568-.07-.6939-.21-1.0111-.14-.3173-.31-.6117-.51-.8833l-.52-.6926c-.0933-.1222-.2133-.1833-.36-.1833s-.2667.0611-.36.1833l-.52.6926c-.2133.2716-.3867.566-.52.8833-.1333.3172-.2.6543-.2 1.0111 0 .4568.1544.8426.4631 1.1574Z">
            </path>
            <path fill-rule="evenodd"
              d="M11.0506 1.01682c.1198-.359279-.0744-.747612-.4336-.867371-.3593-.1197581-.74766.074409-.86741.433684L9.058 2.65788l-.88815-.88816c-.53558-.53557-1.40392-.53557-1.9395 0l-4.4605 4.46051c-.53558.53558-.53558 1.40391 0 1.93949l4.4605 4.46048c.15077.1508.3279.2591.51656.325.31398.1097.65988.1017.96926-.0237.1651-.067.31981-.1674.45371-.3013l4.46052-4.46048c.5355-.53557.5355-1.40391 0-1.93949l-2.4882-2.48814.9084-2.72527ZM8.57313 4.1125l-.42354 1.27063c-.11976.35928.0744.74761.43368.86737.35927.11976.74761-.07441.86737-.43368l.2067-.62011 2.00326 2.00327H2.73959L7.2001 2.73947 8.57313 4.1125Z"
              clip-rule="evenodd"></path>
          </svg>
          <span class="window-titles">Other styles</span>
        </div>
      </div>
      <div class="close-button" data-bs-dismiss="offcanvas">
        Close
      </div>
    </div>



  </div>

  <div class="offcanvas offcanvas-style offcanvas-end custom-offcanvas" data-bs-scroll="true" data-bs-backdrop="false"
    id="sideBar" aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas-header">
      <p id="offcanvasRightLabel" *ngIf="selectedGlobal === 'color'" class="header-text mb-0">Color Palette</p>
      <p id="offcanvasRightLabel" *ngIf="selectedGlobal === 'buttons'" class="header-text mb-0">Button Styles</p>
      <p id="offcanvasRightLabel" *ngIf="selectedGlobal === 'font'" class="header-text mb-0">Fonts</p>
      <p id="offcanvasRightLabel" *ngIf="selectedGlobal === 'others'" class="header-text mb-0">Other Styles</p>
      <button type="button" data-bs-dismiss="offcanvas" aria-label="Close" class="doneBtn">Done</button>
    </div>
    <div class="offcanvas-body">
      <!-- Pallete -->
      <div *ngIf="selectedGlobal === 'color' ">
        <app-bg-color-palette [templatePage]="templatePage" [themes]="themes"></app-bg-color-palette>
      </div>
      <!-- Buttons -->
      <div class="buttons" *ngIf="selectedGlobal === 'buttons'">
        <app-global-button-styles [templatePage]="templatePage"></app-global-button-styles>
      </div>
      <!-- Fonts -->
      <div class="fonts" *ngIf="selectedGlobal === 'font' ">
        <div class="font-families">
          <ng-container *ngFor="let item of fontFamilies">
            <div class="card-section border rounded bg-white px-4 py-2 cursor-pointer"
              [ngClass]="{'card-selected': item.text === selectedFont}" (click)="selectedFontFamily(item)">
              <div class="font-title" [style.fontFamily]="item.text">
                {{item.text}}
              </div>
              <div class="font-subtext text-sm text-gray-500" [style.fontFamily]="item.text">
                {{ item.subtext }}
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- Other Styles -->
      <div class="other_styles" *ngIf="selectedGlobal === 'others'">
        <app-other-styles [templatePage]="templatePage"></app-other-styles>
      </div>
    </div>

  </div>

</div>

<div class="navbar-component" *ngIf="scrWidth < 475">
  <div class="d-flex align-items-center" style="width: 12%;">
    <button data-bs-target="#staticBackdrop" data-bs-toggle="modal"
      class="border"><mat-icon>keyboard_backspace</mat-icon></button>
  </div>
  <div class="add_business d-flex" style="width: 60%; gap: 7px;">
    <div class="add_page d-flex alig-items-center justify-content-between" (click)="pageListComponent()">
      <div class="home-text">
        {{selectedPage}}
      </div>
      <div>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </div>
    </div>
    <div class="multi_page d-flex border" style="padding: 0 0;" (click)="showPageList()">
      <button class="button-style d-flex justify-content-center align-items-center"
        style="border: none; border-radius: 5px;">
        <mat-icon>add</mat-icon></button>
    </div>
  </div>
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>edit</mat-icon>
  </button>
  <button (click)="savePage()" class="border" [class.border1]="scrWidth < 475">Save</button>
  <mat-menu #menu="matMenu" style="width: 25%;">
    <button class="button-style" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom"
      aria-controls="offcanvasBottom" mat-menu-item>
      <span style="display: flex; gap: 5px;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16" style="width: 10%;"
          class="icon w-5 h-5" aria-hidden="true">
          <path
            d="M12.4632 14.7277c.3088.3149.6854.4723 1.13.4723.4446 0 .8236-.1574 1.1369-.4723.3133-.3148.47-.7006.47-1.1574 0-.3568-.07-.6939-.21-1.0111-.14-.3173-.31-.6117-.51-.8833l-.52-.6926c-.0933-.1222-.2133-.1833-.36-.1833s-.2667.0611-.36.1833l-.52.6926c-.2133.2716-.3867.566-.52.8833-.1333.3172-.2.6543-.2 1.0111 0 .4568.1544.8426.4631 1.1574Z">
          </path>
          <path fill-rule="evenodd"
            d="M11.0506 1.01682c.1198-.359279-.0744-.747612-.4336-.867371-.3593-.1197581-.74766.074409-.86741.433684L9.058 2.65788l-.88815-.88816c-.53558-.53557-1.40392-.53557-1.9395 0l-4.4605 4.46051c-.53558.53558-.53558 1.40391 0 1.93949l4.4605 4.46048c.15077.1508.3279.2591.51656.325.31398.1097.65988.1017.96926-.0237.1651-.067.31981-.1674.45371-.3013l4.46052-4.46048c.5355-.53557.5355-1.40391 0-1.93949l-2.4882-2.48814.9084-2.72527ZM8.57313 4.1125l-.42354 1.27063c-.11976.35928.0744.74761.43368.86737.35927.11976.74761-.07441.86737-.43368l.2067-.62011 2.00326 2.00327H2.73959L7.2001 2.73947 8.57313 4.1125Z"
            clip-rule="evenodd"></path>
        </svg>
        <div style="font-size: 14px;">
          Styles
        </div>
      </span>
    </button>
    <button *ngIf="mobileStatus === 'PUBLISHED'" class="view" (click)="viewPopup()" mat-menu-item>
      <span style="display: flex; gap: 5px;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" style="width: 10%;" fill="currentColor"
          aria-hidden="true" class="icon w-5 h-5">
          <path fill-rule="evenodd"
            d="M4.25 5.5a.75.75 0 00-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 00.75-.75v-4a.75.75 0 011.5 0v4A2.25 2.25 0 0112.75 17h-8.5A2.25 2.25 0 012 14.75v-8.5A2.25 2.25 0 014.25 4h5a.75.75 0 010 1.5h-5z"
            clip-rule="evenodd"></path>
          <path fill-rule="evenodd"
            d="M6.194 12.753a.75.75 0 001.06.053L16.5 4.44v2.81a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 000 1.5h2.553l-9.056 8.194a.75.75 0 00-.053 1.06z"
            clip-rule="evenodd"></path>
        </svg>
        <div style="font-size: 14px;">
          View
        </div>
      </span>
    </button>
    <button *ngIf="mobileStatus === 'NOT_PUBLISHED'" class="view d-flex justify-content-center alig-items-center"
      (click)="changeStatus()" mat-menu-item style="display: flex; gap: 5px;">
      <span style="display: flex; gap: 5px;">
        <svg style="width: 17%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
          aria-hidden="true" class="icon w-5 h-5">
          <path fill-rule="evenodd"
            d="M4.606 12.97a.75.75 0 01-.134 1.051 2.494 2.494 0 00-.93 2.437 2.494 2.494 0 002.437-.93.75.75 0 111.186.918 3.995 3.995 0 01-4.482 1.332.75.75 0 01-.461-.461 3.994 3.994 0 011.332-4.482.75.75 0 011.052.134z"
            clip-rule="evenodd"></path>
          <path fill-rule="evenodd"
            d="M5.752 12A13.07 13.07 0 008 14.248v4.002c0 .414.336.75.75.75a5 5 0 004.797-6.414 12.984 12.984 0 005.45-10.848.75.75 0 00-.735-.735 12.984 12.984 0 00-10.849 5.45A5 5 0 001 11.25c.001.414.337.75.751.75h4.002zM13 9a2 2 0 100-4 2 2 0 000 4z"
            clip-rule="evenodd"></path>
        </svg>
        <div style="font-size: 14px;">Publish</div>
      </span>
    </button>
  </mat-menu>

</div>

<div class="modal fade backdrop-blur" id="staticBackdrop" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-width-23">
    <div class="modal-content">
      <div class="exit-popup-body">
        <div class="exit-icon-bg">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none" stroke="#EF4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            aria-hidden="true">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </div>
        <h3 class="exit-title">Exit?</h3>
        <p class="exit-desc">Any unsaved changes will be discarded. This cannot be undone.</p>
      </div>
      <div class="exit-actions">
        <button class="exit-cancel" type="button" (click)="closeDialog()" data-bs-dismiss="modal">Go Back</button>
        <button class="exit-confirm" data-bs-dismiss="modal" (click)="goBack()">Yes, Exit</button>
      </div>
    </div>
  </div>
</div>